import { Component, OnInit } from '@angular/core';
import { NotificationType } from 'src/app/models/notification.message';
import { LocationRequest } from 'src/app/models/requests/location-request';
import { AxiomsService } from 'src/app/services/axiom.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-new-axiom',
  templateUrl: './new-axiom.component.html',
  styleUrls: ['./new-axiom.component.css']
})
export class NewAxiomComponent  {
  name: string = '';
  description: string = '';

  constructor(private axiomService: AxiomsService,  private notification: NotificationService) { }

  onSubmit(): void {
    let LocationVm: LocationRequest = {
      name: this.name,
      description: this.description,
    };

    this.axiomService.saveAxiom(LocationVm).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          console.debug(`Location Created successfully ${data}`);
          this.description = '';
          this.name = ''

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }

}
